module.exports = __webpack_public_path__ + "img/icb-co-Inte-e@3x.43d00850.png";